const pageContent = document.getElementById('page-content');
const reviewButton = document.getElementById('review-selections-button');
const clearButton = document.getElementById('clear-selections-button');
const reviewSelectedPane = document.getElementById('review-selected-pane');
const addToClassroomButton = document.getElementById('add-to-classroom-button');

class Selections {
    constructor(storage, toolbar) {
        this.storage = storage;
        this.toolbar = toolbar;
    }

    initialize(toggles, eventHandlers) {
        if (toggles.length === 0) return;

        if (eventHandlers) this.eventHandlers = eventHandlers;
        toggles.forEach(toggle => this.initializeToggle(toggle));
    }

    initializeToggle(toggle) {
        const resource = toggle.parentElement;

        if (!resource.dataset.selectToggleInitialized) {
            resource.addEventListener('click', event => {
                if (this.clickedInsideThumbnail(event, resource)) return;
                if (this.clickedDetailedViewLink(event, resource)) return;
                this.onToggleClick(toggle);
            });

            resource.dataset.selectToggleInitialized = true;
        }
        
        this.initializeResource(resource);
    }

    clickedInsideThumbnail(event, resource) {
        const resourceThumbnail = resource.querySelector('.resource-thumbnail');
        return resourceThumbnail && resourceThumbnail.contains(event.target);
    }

    clickedDetailedViewLink(event, resource) {
        const clickedOnToggleNext = event.target.classList.contains('toggle-next');
        const clickedOnLink = event.target.tagName.toLowerCase() === 'a';
        const description = resource.querySelector('.description');
        return description && (clickedOnToggleNext || clickedOnLink) && description.contains(event.target);
    }

    initializeResource(resource) {
        if (this.storage.has(resource.dataset.id)) {
            this.select(resource);
        } else {
            this.deselect(resource);
        }
    }

    onToggleClick(toggle) {
        const resource = toggle.parentElement;
        const resourceId = resource.dataset.id;
        const resources = [...document.querySelectorAll(`.resource[data-id='${resourceId}']`)];
    
        if (this.storage.has(resourceId)) {
            this.toggleOff(resourceId, resources);
        } else {
            this.toggleOn(resourceId, resources);
        }
    }

    toggleOff(resourceId, resources) {
        resources.forEach(resource => this.deselect(resource));
        this.storage.delete(resourceId);
        const selectionsCount = this.storage.size;

        this.toolbar.decrement(selectionsCount);

        if (selectionsCount === 0) {
            this.handleAllSelectionsCleared();
        }
    }

    toggleOn(resourceId, resources) {
        this.checkForSessionTimeout();
        resources.forEach(resource => this.select(resource));
        this.storage.add(resourceId);
        this.toolbar.increment(this.storage.size);
    }

    select(resource) {
        resource.classList.add('selected');
    }

    deselect(resource) {
        resource.classList.remove('selected');
    }

    clear() {
        let selector;

        if (this.toolbar.isReviewingResources()) {
            selector = '#review-selected-pane .resource.selected';
        } else {
            selector = '#resource-grid .resource.selected';
            this.checkForSessionTimeout();
        }

        this.storage.clear();
        const resources = [...document.querySelectorAll(selector)];

        if (resources.length > 0) {
            resources.forEach(resource => this.toggleOff(resource.dataset.id, resources));
        } else {
            this.toolbar.decrement(0);
            this.handleAllSelectionsCleared();
        }
    }

    handleAllSelectionsCleared() {
        if (this.toolbar.isReviewingResources()) {
            this.toolbar.hideReview(true);

            if (this.eventHandlers.handleClearSelections) {
                this.eventHandlers.handleClearSelections(true);
            }
        }
        
        this.toolbar.hide();
    }

    checkForSessionTimeout() {
        const apiRequest = () => axios.get('/v3/resource-gallery/session');
        const onAuthError = () => window.location.href = '/resource-gallery';
        submitApiRequest({apiRequest, onAuthError});
    }
}

class Toolbar {
    constructor() {
        this.toolbar = document.getElementById('selections-toolbar');
        this.counter = this.toolbar.getElementsByClassName('selections-counter')[0];
    }

    increment(selectionsCount) {
        this.show(selectionsCount);
        this.toolbar.classList.add('increment');
        setTimeout(() => this.toolbar.classList.remove('increment'), 400);
    }

    decrement(selectionsCount) {
        this.show(selectionsCount);
        this.toolbar.classList.add('decrement');
        setTimeout(() => this.toolbar.classList.remove('decrement'), 400);
    }

    show(selectionsCount) {
        this.setCounter(selectionsCount);
        this.toolbar.classList.add('show');
    }

    hide() {
        this.toolbar.classList.remove('show');
    }

    setCounter(count) {
        this.counter.innerHTML = count;
    }

    transition() {
        pageContent.classList.add('transition');
        setTimeout(() => pageContent.classList.remove('transition'), 800);
    }
    
    showReview() {
        pageContent.classList.remove('hide-review-selections');
        pageContent.classList.add('show-review-selections');
        this.transition();

        setTimeout(() => {
            this.toolbar.classList.add('position-sticky');
            reviewButton.innerHTML = 'Back to Gallery';
        }, 300);
    }
    
    hideReview(skipTransition) {
        pageContent.classList.remove('show-review-selections');
        pageContent.classList.add('hide-review-selections');
        setTimeout(() => this.toolbar.classList.remove('position-sticky'), 300);
        if (!skipTransition) this.transition();
        reviewButton.innerHTML = 'Review';
        reviewSelectedPane.innerHTML = '';
    }

    isReviewingResources() {
        return pageContent.classList.contains('show-review-selections');
    }
}

class ResourceSelections {
    constructor(selections, toolbar, storage) {
        this.selections = selections;
        this.toolbar = toolbar;
        this.storage = storage;

        reviewButton.addEventListener('click', this.onReviewSelections.bind(this));
        clearButton.addEventListener('click', this.onClearSelections.bind(this));
    }

    initialize(toggles, eventHandlers) {
        if (eventHandlers) this.eventHandlers = eventHandlers;
        this.selections.initialize(toggles, eventHandlers);
    }

    onReviewSelections(event) {
        if (this.eventHandlers.handleReviewSelections) {
            this.eventHandlers.handleReviewSelections(this.toolbar.isReviewingResources(), event);
        }
    }

    onClearSelections() {
        this.selections.clear();
    }

    showReview() {
        return this.toolbar.showReview();
    }

    hideReview(skipTransition) {
        return this.toolbar.hideReview(skipTransition);
    }

    getSelections() {
        return [...this.storage.values()];
    }
}

const storage = new Set();
const toolbar = new Toolbar();
const selections = new Selections(storage, toolbar);

window.selections = new ResourceSelections(selections, toolbar, storage);
